import * as React from "react";
import { ViewMedium, Viewport, ViewSmall } from "bernie-view";

import { PackageCards } from "./PackageCards";

const FlightHotel = (props: any) => {
  const { context, model } = props;
  const { packages, viewType, showChooseYourDates } = model;

  return (
    <Viewport>
      <ViewSmall>
        <PackageCards
          context={context}
          packages={packages}
          isMobile={true}
          isFullWidth={true}
          viewType={viewType}
          showChooseYourDates={showChooseYourDates}
        />
      </ViewSmall>
      <ViewMedium>
        <PackageCards
          context={context}
          packages={packages}
          isMobile={false}
          isFullWidth={false}
          viewType={viewType}
          showChooseYourDates={showChooseYourDates}
        />
      </ViewMedium>
    </Viewport>
  );
};

export default FlightHotel;
